import { connect } from 'react-redux';

import { Navigation } from './index';
import { IState } from '../../store';
import { setNavigationMenuVisibility } from '../../store/navigation/actions';
import { TNavigationLinkType } from '../../types';
import { TTypedThunkDispatch } from '../../types/store';

export interface INavigationStoreProps {
  links: TNavigationLinkType[];
  isFat?: boolean;
}

export interface INavigationDispatchProps {
  setNavigationMenuVisibility(isMenuVisible: boolean): void;
}

export function mapStateToProps(state: IState): INavigationStoreProps {
  return {
    links: state.navigationLinks.links,
    isFat: state.isFatCard,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): INavigationDispatchProps {
  return {
    setNavigationMenuVisibility: (isMenuVisible: boolean) => dispatch(setNavigationMenuVisibility(isMenuVisible)),
  };
}

export const NavigationContainer = connect<INavigationStoreProps, INavigationDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Navigation);
